const LISTING_SUMMARY_DISPLAY_STATUS = {
  DECLINED: 'declined',
  INACTIVE: 'inactive',
  PARTIALLY_PUBLISHED: 'partially published',
  PUBLISHED: 'published',
  PUBLISHING: 'publishing',
  WAITLISTED: 'waitlisted',
} as const;

export { LISTING_SUMMARY_DISPLAY_STATUS };
